export default "__VITE_ASSET__CCiKTUsK__"